import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from "@angular/core";
import { LayoutWidget } from "../../layouts/se.layout.widget.abstract";
import { Layouts } from "../../layouts/se.layouts";
import { SeOrgDetailsStore } from "../se.org.details.store";
import { S25OrgContactRolesComponent } from "../../../object-details/organization/s25.org.contact.roles.component";

@Component({
    standalone: true,
    selector: "s25-ng-se-org-members-widget",
    template: `
        @if (orgStore.orgId() && orgStore.members()) {
            <s25-ng-org-contact-roles
                [itemId]="orgStore.orgId()!"
                [contacts]="orgStore.members()!() ?? []"
                [canEdit]="false"
            />
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.Emulated,
    imports: [S25OrgContactRolesComponent],
})
export class SeOrgMembersWidgetComponent extends LayoutWidget<typeof SeOrgMembersWidgetComponent> {
    static readonly META = {
        name: "Officers / Members",
        info: "Displays organization members and their roles. Requires member access permission.",
        /** Requires SE_ORG_CONTACTS Read + MANAGE_MEMBERS status check. */
        flsFloor: "canViewMembers",
        settings: [],
        defaultSettings: {},
    } as const satisfies Layouts.WidgetStatic;

    protected readonly orgStore = inject(SeOrgDetailsStore);
}
